import $ from "jquery";

export var productSwiper = {

    defaultOptions: {
        slidesPerView: 1.25,
        spaceBetween: 0,
        loop: false,
        breakpoints: {
            // Responsive breakpoints (optional)
            380: {
                slidesPerView: 1.5,
            },
            640: {
                slidesPerView: 2,
            },
            1024: {
                slidesPerView: 5,
            }
        }
    },

    init: function () {
        $('.products--swiper').each(function (){
            var $parent = $(this).parent();
            productSwiper.initProductSwiperOnContainer($parent);
        });

        $('.category--swiper').each(function(){
            new Swiper($(this)[0], {
                slidesPerView: 1,
                spaceBetween: 0,
                loop: true,
                autoHeight: true,
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: true,
                },
            });
        });
    },

    initProductSwiperOnContainer: function ($container, options) {
        const $nextButton = $container.find('.swiper-next')[0];
        const $prevButton = $container.find('.swiper-prev')[0];
        const $swiper = $container.find('.products--swiper')[0];


        var nav = {
            navigation: {
                nextEl: $nextButton,
                prevEl: $prevButton,
            }
        };

        options = $.extend(true, {}, productSwiper.defaultOptions, options, nav);

        console.log(options);

        new Swiper($swiper, options);
    },

    createSwiperOnContainer: function ($container) {
        var $productList = $container.find('.productlist');
        $productList.addClass('swiper products--swiper products--swiper--bordered');
        var $list = $productList.find('.list');
        $productList.find('.list').addClass('swiper-wrapper');

        $list.children().each(function () {
            var $item = $(this);

            if (!$item.hasClass('swiper-slide')) {
                $item.wrap('<div class="swiper-slide"></div>');
            }
        });

        $productList.append('' +
            '<div class="swiper-navigation">' +
                '<div class="swiper-prev"></div>' +
                '<div class="swiper-next"></div>' +
            '</div>');

        productSwiper.initProductSwiperOnContainer($container);
    }
};

$(function (){
   productSwiper.init();
});
